import React, { useState } from 'react';
import BasePOIModal from './BasePOIModal';
import { MeasurementSelector } from './components/MeasurementSelector';
import { NotesAndPhotos } from './components/NotesAndPhotos';
import { WidthClearance } from './components/WidthClearance';

export const CustomPOIModal = ({ type, poiInfo, onClose, onSave, onBack }) => {
  const [formData, setFormData] = useState({
    customName: '',
    customDescription: '',
    width: { feet: '', inches: '', meters: '' },
    touchLevel: null,
    measurementType: 'touch',
    customHeight: { feet: '', inches: '', meters: '' },
    notes: '',
    photos: []
  });

  const handleSubmit = async () => {
    // Validate required fields
    const errors = {};
    if (!formData.customName.trim()) errors.customName = 'Name is required';
    if (formData.measurementType === 'touch' && !formData.touchLevel) {
      errors.measurements = 'Touch level is required';
    }
    if (formData.measurementType === 'custom' && 
        !formData.customHeight.feet && 
        !formData.customHeight.meters) {
      errors.measurements = 'Height measurement is required';
    }

    if (Object.keys(errors).length > 0) {
      return { success: false, errors };
    }

    // Prepare measurements array
    const measurements = [];
    if (formData.measurementType === 'touch') {
      measurements.push({
        type: 'touch',
        value: formData.touchLevel,
        unit: 'inches'
      });
    } else {
      if (formData.customHeight.meters) {
        measurements.push({
          type: 'custom',
          value: parseFloat(formData.customHeight.meters),
          unit: 'meters'
        });
      } else {
        measurements.push({
          type: 'custom',
          value: parseInt(formData.customHeight.feet),
          unit: 'feet'
        });
        if (formData.customHeight.inches) {
          measurements.push({
            type: 'custom',
            value: parseInt(formData.customHeight.inches),
            unit: 'inches'
          });
        }
      }
    }

    return onSave({
      measurements,
      notes: formData.notes,
      photos: formData.photos,
      customDetails: {
        name: formData.customName,
        description: formData.customDescription
      }
    });
  };

  return (
    <BasePOIModal
      type={type}
      poiInfo={poiInfo}
      onClose={onClose}
      onSave={handleSubmit}
      onBack={onBack}
    >
      <div className="space-y-6">
        <MeasurementSelector
          measurementType={formData.measurementType}
          setMeasurementType={(type) => setFormData(prev => ({ ...prev, measurementType: type }))}
          touchLevel={formData.touchLevel}
          setTouchLevel={(level) => setFormData(prev => ({ ...prev, touchLevel: level }))}
          customHeight={formData.customHeight}
          setCustomHeight={(height) => setFormData(prev => ({ ...prev, customHeight: height }))}
        />

        <WidthClearance 
          width={formData.width}
          setWidth={(width) => setFormData(prev => ({ ...prev, width }))}
        />

        <div>
          <label className="block text-gray-400 mb-2">POI Name</label>
          <input
            type="text"
            value={formData.customName}
            onChange={(e) => setFormData(prev => ({ ...prev, customName: e.target.value }))}
            className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white"
            placeholder="Enter POI name"
            required
          />
        </div>

        <div>
          <label className="block text-gray-400 mb-2">Description</label>
          <textarea
            value={formData.customDescription}
            onChange={(e) => setFormData(prev => ({ ...prev, customDescription: e.target.value }))}
            className="w-full bg-gray-700 border border-gray-600 rounded px-3 py-2 text-white h-24 resize-none"
            placeholder="Enter POI description"
          />
        </div>

        <NotesAndPhotos
          notes={formData.notes}
          setNotes={(notes) => setFormData(prev => ({ ...prev, notes }))}
          photos={formData.photos}
          setPhotos={(photos) => setFormData(prev => ({ ...prev, photos }))}
        />
      </div>
    </BasePOIModal>
  );
};

export default CustomPOIModal;